import React, {FC} from "react";
import {CompletionCelebrationContentDrawer} from "./CompletionCelebrationContentDrawer";
import {CompletionCelebrationContentModal} from "./CompletionCelebrationContentModal";
import {useMq} from "@buildwitt/shapeshift-common/v1/hooks";

interface IProps {
	open: boolean;
	onClose: (needsToContinue: boolean) => void;
	courseTitle?: string;
}

export const CompletionCelebrationWrap: FC<IProps> = ({open, onClose, courseTitle}) => {
	const mq = useMq();
	return (
		<>
			{mq.mobile
				? <CompletionCelebrationContentDrawer open={open} onClose={(needsToContinue) => onClose?.(needsToContinue)} courseTitle={courseTitle}/>
				: <CompletionCelebrationContentModal open={open} onClose={(needsToContinue) => onClose?.(needsToContinue)} courseTitle={courseTitle}/>
			}
		</>
	);
};
